import React from "react";
import StoreName from "./StoreName";
import Account from "./Account";
import TabsThree from "../../requests/shared/helpers/TabsThree";
import ScheduleTypeFilter from "./ScheduleTypeFilter";
import Notifications from "./Notifications";
import MonthScheduleTypeGrouping from "./MonthScheduleTypeGrouping";

function MonthlyTopBarDisplay(props) {
  const [activeTab, setActiveTab] = React.useState('Month')

  function handleTabButtonPress(target) {
    setActiveTab(target)
    props.setView(target, 0)
  }

  return (
    <div className="w-full">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <div className={`${props.windowWidth > 1100 ? "w-80" : "w-72"}`}>
            <MonthScheduleTypeGrouping
              currentMonth={props.currentMonth}
              currentYear={props.currentYear}
              increment_month={props.increment_month}
              setCurrentMonth={props.setCurrentMonth}
              setCurrentYear={props.setCurrentYear}
            />
          </div>
          {props.windowWidth > 1300 &&
            <div className="w-52">
              <TabsThree
                activeTab={activeTab}
                handleTabButtonPress={handleTabButtonPress}
                tab1="Week"
                tab2="Day"
                tab3="Month"
                type="TopBar"
              />
            </div>
          }
        </div>
        <div className="flex items-center">
          <div className="mr-4">
            <ScheduleTypeFilter
              roleType={props.roleType}
              setRoleType={props.setRoleType}
              roleTypeOptions={props.roleTypeOptions}
            />
          </div>
          <div className="mr-6">
            <StoreName
              storeOptions={props.storeOptions}
              homeStore={props.homeStore}
              storeNames={props.storeNames}
              change_home_store={props.change_home_store}
            />
          </div>
          <div className="mr-8">
            <Notifications
              homeStore={props.homeStore}
            />
          </div>
          <div className="h-10 flex items-center justify-center cursor-pointer">
            <Account />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MonthlyTopBarDisplay;
